<template>
  <el-dialog
    :title="dialogTtile"
    :visible.sync="visible"
    width="750px"
    @close="$emit('update:show', false)"
    @open="handleOpen"
    :close-on-click-modal="false"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
      size="small"
    >
      <el-form-item label="名称" prop="title">
        <el-input v-model="model.title"></el-input>
      </el-form-item>
      <el-form-item label="资料类别" prop="tag" v-if="model.type == 1">
        <TagNameSelect
          v-if="visible"
          v-model="model.tag"
          style="width: 100%"
        ></TagNameSelect>
      </el-form-item>
      <el-form-item label="是否公开" prop="is_public" v-if="model.type == 1">
        <el-select v-model="model.is_public" style="width: 100%">
          <el-option
            label="是（内部和外部人员均可见）"
            :value="1"
            key="1"
          ></el-option>
          <el-option
            label="否（仅平台内部人员可见）"
            :value="2"
            key="2"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="有效期" prop="dates">
        <el-date-picker
          style="width: 100%"
          class="date-range"
          v-model="dates"
          type="daterange"
          range-separator="至"
          start-placeholder="发布日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <div class="text-info font-12 line-height-1 mt-5">
          生效规则：此项设置了值且知识库为发布状态。
        </div>
      </el-form-item>
      <el-form-item label="关联设备分类" prop="item_category_ids">
        <MultiItemCategorySelect
          v-if="visible"
          v-model="model.item_category_ids"
          :category="2"
        ></MultiItemCategorySelect>
      </el-form-item>
      <el-form-item label="正文形式" prop="content_type">
        <el-select v-model="model.content_type" style="width: 100%">
          <el-option label="网页链接" :value="1" key="1"></el-option>
          <el-option label="自定义" :value="2" key="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="model.content_type == 1 ? '链接地址' : '正文内容'"
        prop="content"
      >
        <el-input
          v-model="model.content"
          v-if="model.content_type == 1"
        ></el-input>
        <rich-editor
          class="editor"
          v-else
          v-model="model.content"
        ></rich-editor>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { createWiki, updateWiki } from '@/service/getData'
import MultiItemCategorySelect from './MultiItemCategorySelect.vue'
import RichEditor from '@/components/rich-editor'
import TagNameSelect from './TagNameSelect.vue'

export default {
  components: {
    MultiItemCategorySelect,
    RichEditor,
    TagNameSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  computed: {
    dialogTtile() {
      if (this.model.type == 2) {
        return this.model.id > 0 ? '编辑市场活动' : '新增市场活动'
      }
      return this.model.id > 0 ? '编辑知识库' : '新增知识库'
    },
  },
  data() {
    return {
      visible: this.show,
      dates: '',
      rules: {
        title: [{ required: true, message: '请填写名称' }],
        is_public: [
          { required: true, message: '请选择是否公开', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    handleOpen() {
      if (this.model.start_date) {
        this.dates = [this.model.start_date, this.model.end_date]
      } else {
        this.dates = ''
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.dates && this.dates.length == 2) {
            this.model.start_date = this.dates[0]
            this.model.end_date = this.dates[1]
          }
          if (this.model.id > 0) {
            let res = await updateWiki(this.model)
            if (res.code == 0) {
              this.visible = false
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createWiki(this.model)
            if (res.code == 0) {
              this.visible = false
              this.$emit('created', res.data)
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
/deep/.ql-editor {
  min-height: 200px;
}

/deep/.ql-formats {
  line-height: 0;
}
</style>